import {Component, OnInit} from '@angular/core';
import {GapService} from '../../api/services/gap/gap.service';
import {GlobalService} from '../../api/services/global/global.service';
import {GapPremiumsRequest} from '../../api/models/gap-premiums-request';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {GapSendQuoteRequest} from '../../api/models/gap-send-quote-request';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ContentService} from '../../api/services/content-service/content.service';
import {GapPlanBenefit} from '../../api/models/gap-plan-benefit';

declare var jcf: any;
declare let jQuery: any;
declare var $: any;

@Component({
  selector: 'app-view-quotes',
  templateUrl: './view-premium.component.html',
  styleUrls: ['./view-premium.component.css']
})
export class ViewPremiumComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  searchTerm: number;
  showError: boolean = false;
  errorMessage: string;
  viewPremiumForm: FormGroup;

  // Plan Benefits
  gapComp: GapPlanBenefit;
  gapCore: GapPlanBenefit;
  benefits: string[] = [
    'Hospital Cover',
    'Hospital Admission Benefit Extender',
    'Oncology Benefit Extender',
    'Scopes and Scans Benefit Extender',
    'Travel Benefit Extender',
    'Overall Annual Limit',
    'Supplementary Illness Benefit'
  ];

  // SIB
  compSibAdded: boolean;
  coreSibAdded: boolean;
  reCalculated: boolean = false;
  isAgeOver60: boolean = false;
  smokerStatusError: boolean = false;

  // Send Quote
  selectedPlan: string;
  quoteSaved: boolean = false;
  submitted: boolean = false;
  tcsAccepted: boolean = false;

  constructor(
    private gapService: GapService,
    private formBuilder: FormBuilder,
    protected globalService: GlobalService,
    private router: Router,
    private contentService: ContentService
  ) {
    this.globalService.gapQuoteDetailsResponse = {};
  }

  ngOnInit() {
    this.globalService.scrollToTop();
    this.getPlanBenefits();

    this.submitted = false;
    this.quoteSaved = false;
    this.tcsAccepted = false;
    this.showError = false;
    this.reCalculated = false;
    this.coreSibAdded = this.globalService.includedSIB;
    this.compSibAdded = this.globalService.includedSIB;

    this.isAgeOver60 = this.globalService.calculateAge(this.globalService.healthPolicyMembers.oldestDob) >= 60;

    this.viewPremiumForm = this.formBuilder.group({
      productTcs: [false, Validators.requiredTrue],
      quoteTcs: [false, Validators.requiredTrue],
      clientEmail: [
        this.globalService.clientEmail || '',
        [
          Validators.required,
          Validators.pattern(
            '^[A-Za-z0-9._%+-]{1,64}@(?:[A-Za-z0-9-]{1,63}\\.){1,125}[A-Za-z]{2,63}$',
          ),
        ],
      ],
    });
  }

  private getPremiumsRequest(): GapPremiumsRequest {
    const totalAdults: number = this.globalService.adults.length + this.globalService.spouses.length;
    return {
      medicalSchemePlan: this.globalService.healthPolicyMembers.mainMemberSchemePlan,
      memberSmokerStatus: this.globalService.memberSmoker,
      spouseSmokerStatus: this.globalService.spouses.length > 0 ? this.globalService.spouseSmoker : 'No spouse',
      numAdultDependents: totalAdults.toString(),
      numChildDependents: this.globalService.children.length.toString(),
      effectiveDate: this.globalService.effectiveDate,
      sibIncluded: this.globalService.includedSIB,
      nameAndRole: this.globalService.healthPolicyMembers.members,
    };
  }

  private getSaveGapQuoteRequest(): GapSendQuoteRequest {
    const totalAdults: number = this.globalService.adults.length + this.globalService.spouses.length;
    let gapPremium: string = '';
    let suppPremium: string = '';
    let sibAddedForSelectedPlan: boolean = false;

    if (this.selectedPlan === 'Gap Comprehensive') {
      gapPremium = this.globalService.gapPremiumsResponse.gapCompPremium;
      suppPremium = this.globalService.gapPremiumsResponse.suppCompPremium;
      sibAddedForSelectedPlan = this.compSibAdded;
    } else if (this.selectedPlan === 'Gap Core') {
      gapPremium = this.globalService.gapPremiumsResponse.gapCorePremium;
      suppPremium = this.globalService.gapPremiumsResponse.suppCorePremium;
      sibAddedForSelectedPlan = this.coreSibAdded;
    }

    return {
      quoteTcsAccepted: this.viewPremiumForm.get('quoteTcs').value,
      productTcsAccepted: this.viewPremiumForm.get('productTcs').value,
      memberMedicalPlan: this.globalService.healthPolicyMembers.mainMemberSchemePlan,
      selectedGapPlan: this.selectedPlan,
      selectedGapPremium: gapPremium && (gapPremium.includes(',') ? gapPremium.replace(',', '') : gapPremium),
      selectedSupplementary: sibAddedForSelectedPlan ? 'Supplementary Gap Cover' : '',
      selectedSuppPremium: sibAddedForSelectedPlan ? (suppPremium.includes(',') ? suppPremium.replace(',', '') : suppPremium) : null,
      selectedGapPlanOption: sibAddedForSelectedPlan ? 'Discovery '
        + this.selectedPlan + ' and Discovery Supplementary Gap Cover' : 'Discovery '
        + this.selectedPlan,
      memberSmokerStatus: this.globalService.memberSmoker,
      spouseSmokerStatus: this.globalService.spouses.length > 0 ? this.globalService.spouseSmoker : 'No spouse',
      childDependents: this.globalService.children.length.toString(),
      adultDependents: totalAdults.toString(),
      effectiveDate: this.globalService.effectiveDate,
      premiumInfo: this.globalService.gapPremiumsResponse,
      clientEmail: this.viewPremiumForm.get('clientEmail').value,
    } as GapSendQuoteRequest;
  }

  protected saveGapQuote(): void {
    this.submitted = true;

    const emailInvalid = this.viewPremiumForm.get('clientEmail').invalid;
    const tcsInvalid =
      !this.viewPremiumForm.get('productTcs').value ||
      !this.viewPremiumForm.get('quoteTcs').value;

    if (emailInvalid || tcsInvalid) {
      return;
    }

    try {
      if (typeof $ !== 'undefined' && $.fn && $.fn.modal) {
        $("#sendQuote").modal('hide');
      }

      if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.modal) {
        jQuery("#sendQuote").modal('hide');
      }

      const modalElement = document.getElementById('sendQuote');
      if (modalElement) {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('padding-right');
      }
    } catch (error) {
      console.error('Error closing modal:', error);
    }

    this.blockUI.start();

    this.gapService
      .saveGapQuoteDetails(this.getSaveGapQuoteRequest())
      .subscribe(
        () => {
          this.quoteSaved = true;
          this.tcsAccepted = true;
          this.blockUI.stop();
        },
        () => {
          this.blockUI.stop();
          this.showError = true;
          this.errorMessage =
            'Failed to send gap quote to client, please try again later.';
        },
      );
  }

  protected reCalculatePremiums(): void {
    if (this.globalService.includedSIB && !this.reCalculated) {

      const isMemberSmokerSet = this.globalService.memberSmoker === 'Smoker' || this.globalService.memberSmoker === 'Non-smoker';
      const isSpouseSmokerSet = this.globalService.spouses.length === 0 || (this.globalService.spouseSmoker === 'Smoker' || this.globalService.spouseSmoker === 'Non-smoker');

      if (!isMemberSmokerSet || !isSpouseSmokerSet) {
        this.smokerStatusError = true;
        return;
      }

      this.closeModal('addSIB')

      this.reCalculated = true;
      this.blockUI.start();

      this.gapService.getGapPremiums(this.getPremiumsRequest()).subscribe(
        (response) => {
          if (response) {
            this.globalService.gapPremiumsResponse = response;
          }
          this.blockUI.stop();
        },
        () => {
          this.blockUI.stop();
          this.showError = true;
          this.errorMessage = 'Failed to add Supplementary Illness Benefit.';
        });
    }
  }

  protected addSIB(planSelected: string): void {
    if (planSelected === 'core') {
      this.coreSibAdded = true;
    } else {
      this.compSibAdded = true;
    }
    this.globalService.includedSIB = true;
    this.reCalculated = false;
  }

  protected removeSIB(planSelected: string): void {
    if (planSelected === 'core') {
      this.coreSibAdded = false;
    } else {
      this.compSibAdded = false;
    }

    if (!this.coreSibAdded && !this.compSibAdded) {
      this.globalService.includedSIB = false;
    }
  }

  protected memberSmokerSelection(event: any): void {
    this.jcfReload();
    this.globalService.memberSmoker = event.target.value;
    this.smokerStatusError = false;
  }

  protected spouseSmokerSelection(event: any): void {
    this.jcfReload();
    this.globalService.spouseSmoker = event.target.value;
    this.smokerStatusError = false;
  }

  protected gapPlanSelection(selectedPlan: string): void {
    this.selectedPlan = selectedPlan;
    this.contentService.scrollToTop();
  }

  protected navigateToHome(): void {
    this.router.navigateByUrl('view-quotes').then(navigated => {
      if (navigated) {
        this.globalService.returnedToHome = true;
      }
    });
  }

  private getPlanBenefits(): void {
    this.contentService.getPlanBenefits().subscribe(response => {
      if (response) {
        this.gapComp = response.find(itemId => itemId.id === 'Discovery Gap Comprehensive');
        this.gapCore = response.find(itemId => itemId.id === 'Discovery Gap Core');
      }
    },
      () => {
      this.showError = true;
      this.errorMessage = 'Failed to retrieve Gap plan benefits.';
      });
}

  private jcfReload(): void {
    jQuery(function (): void {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  private closeModal(modalId: string): void {
    try {
      if (typeof $ !== 'undefined' && $.fn && $.fn.modal) {
        $(`#${modalId}`).modal('hide');
      }
      if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.modal) {
        jQuery(`#${modalId}`).modal('hide');
      }
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('padding-right');
      }
    } catch (error) {}
  }
}
